import { LINK_ACTIONS } from 'modules/linkExpirationManagement/constants';
import { Controller, useFormContext } from 'react-hook-form';
import { Cell, StyledSelect } from './Table.styled';

export const linkActionOptions = [
  {
    description: 'Redirect users to a 404 page',
    label: 'Terminate link',
    value: LINK_ACTIONS.terminate,
  },
  {
    description: 'Redirect users to a custom URL',
    label: 'Custom redirect',
    value: LINK_ACTIONS.customRedirect,
  },
];

export const LinkActionCell = ({ name }: { name: string }) => {
  const { watch } = useFormContext();
  const linkAction = watch(name);

  return (
    <Cell>
      <Controller
        name={name}
        render={({ field: { onChange } }) => {
          const selectedAction = linkActionOptions.find((op) => op.value === linkAction);
          return (
            <StyledSelect
              isMulti={false}
              menuPlacement="auto"
              options={linkActionOptions}
              onSelect={([option]) => onChange(option.value)}
              usePortal
              value={[selectedAction]}
            />
          );
        }}
      />
    </Cell>
  );
};
